var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"timesince"},[_vm._v(_vm._s(_vm.timeSince)+" "),(_vm.type !== 'chat')?_c('span',[_vm._v(" ago")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }